// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__L-_es","errors":"Errors_errors__r-Lkc"};